<a
  class="nav-link dropdown-toggle nav-icon"
  id="alertsDropdown"
  role="button"
  data-toggle="dropdown"
  aria-haspopup="true"
  aria-expanded="false"
  [matTooltip]="'notify.noti_tooltip' | translate"
>
  <i class="fa fa-tasks fa-fw vt-cursor-pointer" style="margin-left: -3px"></i>
  <!-- Counter - Alerts -->
  <span class="badge badge-danger badge-counter">{{
    totalProcesses == 0 ? "" : totalProcesses
  }}</span>
</a>
<!-- Dropdown - Alerts -->
<div
  class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
  aria-labelledby="alertsDropdown"
>
  <h6 class="dropdown-header">
    {{ "processing_header.processing_title" | translate }}
  </h6>
  <a
    class="dropdown-item"
    style="cursor: pointer"
    *ngFor="let process of processes"
    (click)="redirect(process)"
  >
    <!-- Icon -->
    <!-- <div class="mr-3">
      <div
        class="icon-circle {{ notify.status ? 'bg-secondary' : 'bg-primary' }}"
      >
        <em
          class="fa {{
            notify.status ? 'fa-check-square-o' : 'fa-flag-checkered'
          }} text-white"
        ></em>
      </div>
    </div> -->
    <!-- Text -->
    <div [title]="parsedText(process.code)">
      <p class="mt-2 text-dark">
        <!-- {{ (process.type === 'CUSTOMER_LOT' ? "processing_header.processing_user_title" 
          : process.type === 'USER_LOT' ? "import_file_customer.processing_user_title") | translate }} -->
          {{getTitle(process.type) | translate}}
        <strong>{{ process.code }}</strong>
      </p>
      <div class="small text-gray-700">
        <span
          >{{ (process.type === 'CONTRACT_LOT' ? "processing_header.creating_lot" : "processing_header.processing")| translate }} 
          {{ process.percent ? process.percent : 0 }}%</span
        >
        <mat-progress-bar
          mode="determinate"
          [value]="process.percent"
          [bufferValue]="100"
        >
        </mat-progress-bar>
      </div>
    </div>
  </a>
  <!-- <a
    *ngIf="processes?.length > 0"
    class="dropdown-item text-center small text-gray-700"
    routerLink="/home-enterprise/notify"
    >{{ "notify.view_all" | translate }}</a
  > -->
  <span
    *ngIf="processes?.length === 0"
    class="dropdown-item text-center small text-gray-700"
    >{{ "notify.no_notify" | translate }}</span
  >
</div>
